import { SET_ARCHIVES, SET_AUDIT_RESULTS, SET_REMINDER, SET_REMINDER_ACTION, SET_REMINDER_ARCHIVE, SET_REMINDER_ACTION_ARCHIVE, SET_MAPPED_RULES, SET_ACTIVE_FILES } from "../actions/actionTypes";

const initialState = {
	auditResults: {
		patent: [],
		trademark: []
	},
	archives: [],
	mappedRules: [],
	activeFiles: [],
	uploadTabVisit: false,
	reminderActionPerformed: "",
	reminderArchiveActionPerformed: ""
};

const fileReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_AUDIT_RESULTS: {
			return {
				...state, auditResults: {
					patent: action.payload.patent,
					trademark: action.payload.trademark
				}
			};
		}

		case SET_ARCHIVES: {
			return { ...state, archives: action.payload };
		}

		case SET_REMINDER: {
			return { ...state, uploadTabVisit: action.payload };
		}

		case SET_REMINDER_ACTION: {
			return { ...state, reminderActionPerformed: action.payload };
		}

		case SET_REMINDER_ARCHIVE: {
			return { ...state, uploadTabVisit: action.payload };
		}

		case SET_REMINDER_ACTION_ARCHIVE: {
			return { ...state, reminderArchiveActionPerformed: action.payload };
		}

		case SET_MAPPED_RULES: {
			return { ...state, mappedRules: action.payload };
		}

		case SET_ACTIVE_FILES: {
			return { ...state, activeFiles: action.payload };
		}

		default:
			return state;
	}
};

export default fileReducer;
